// ==================== ORGANIZATIONS SERVICE ====================
// Multiple organizations: a customer's primary organization plus the extra ones
// they added (each with its own WhatsApp number). The business details are the
// customer's own (Settings → Organization), so an added one only has a name.
// Buying more organizations is in the subscription service
// (getOrganizationsQuote / buyOrganizations).

import { apiService } from './api';

// ==================== TYPES ====================

export interface Organization {
  id: string;
  businessName: string;
  status: string;
  createdAt: string;
  /** The organization the customer signed up with */
  isPrimary: boolean;
  whatsapp: { status: string; displayPhoneNumber: string } | null;
}

export interface OrganizationsResponse {
  organizations: Organization[];
  /** Organizations paid for */
  purchased: number;
  /** Organizations added so far */
  created: number;
}

// ==================== SERVICE ====================

const BASE_PATH = '/customer/organizations';

export const organizationsService = {
  async getAll(): Promise<OrganizationsResponse> {
    const response = await apiService.get<OrganizationsResponse>(BASE_PATH);
    if (!response.success || !response.data) {
      throw new Error(response.message || 'Failed to fetch accounts');
    }
    return response.data;
  },

  async create(businessName: string): Promise<Organization> {
    const response = await apiService.post<Organization>(BASE_PATH, { businessName });
    if (!response.success) {
      throw new Error(response.message || 'Failed to add WhatsApp account');
    }
    return response.data as Organization;
  },
};
